import { Injectable, } from '@angular/core';
import { FormArray, FormControl, FormGroup, ValidationErrors } from '@angular/forms';

@Injectable()
export class ValidationHighlightsUtil {
    errorFields = [];
    constructor() { }
    validateAllFormControl(formGroup: FormGroup,nestedkey) {

        Object.keys(formGroup.controls).forEach(field => {
            const control = formGroup.get(field);
            // in case of a FormControl 
            if (control instanceof FormControl) {
                control.markAsTouched({ onlySelf: true });
                const controlErrors: ValidationErrors = control.errors;
                // if (controlErrors != null) {
                //     Object.keys(controlErrors).forEach(keyError => {
                //         this.errorFields.push(field);
                //     });
                // }
                if (controlErrors != null) {
                    Object.keys(controlErrors).forEach(keyError => {
                      if (nestedkey == null) {
                        let data = { field: field, error: keyError }
                        this.errorFields.push(data);
                      }
                      else {
                        let data = { field: nestedkey, error: keyError }
                        this.errorFields.push(data);
                      }
                    });
                  }
            }
            // in case of a formgroup 
            else if (control instanceof FormGroup) {
                this.validateAllFormControl(control,field);
            }
            // In case of a formArray 
            else if (control instanceof FormArray) {
                const formArrayIterator: FormArray = control as FormArray;
                formArrayIterator.controls.forEach((element: FormGroup) => {
                    this.validateAllFormControl(element, null);
                });
            }
        });
        return this.errorFields;
    }
}
